import React from 'react';
import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import PropTypes from 'prop-types';
import withTextInput from './withTextInput';
import withUseEffectErrorMessage from './withUseEffectErrorMessage';

const InputErrorMessage = (props) => {
   return props.isErrorVisible && props.errorMessage
      ? <small className='text-danger'>{props.errorMessage}</small>
      : null;
};

InputErrorMessage.propTypes = {
   isErrorVisible: PropTypes.bool.isRequired,
   errorMessage: PropTypes.string,
};

InputErrorMessage.defaultProps = {
   errorMessage: undefined,
};

const AppendedButtonInput = (props) => {
   return (
      <>
         <InputErrorMessage
            isErrorVisible={!!props.errorMessage}
            errorMessage={props.errorMessage}
         />
         <InputGroup>
            <Input
               type={props.type}
               name={props.name}
               onChange={props.onChange}
               onBlur={props.onBlur}
               value={props.isDisabled && props.isValueHiddenWhenDisabled ? '' : props.value}
               disabled={props.isDisabled}
               className={props.className}
            />
            <InputGroupAddon
               addonType='append'
               onClick={props.onClick}
            >
               <InputGroupText>{props.appendText}</InputGroupText>
            </InputGroupAddon>
         </InputGroup>
      </>
   );
};

AppendedButtonInput.propTypes = {
   name: PropTypes.string.isRequired,
   value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
   onChange: PropTypes.func.isRequired,
   onBlur: PropTypes.func.isRequired,
   isDisabled: PropTypes.bool,
   isValueHiddenWhenDisabled: PropTypes.bool,
   className: PropTypes.string,
   type: PropTypes.string,
   onClick: PropTypes.func.isRequired,
   appendText: PropTypes.string.isRequired,
};

AppendedButtonInput.defaultProps = {
   value: '',
   isDisabled: false,
   isValueHiddenWhenDisabled: false,
   className: '',
   type: 'text',
};

export default withUseEffectErrorMessage(withTextInput(AppendedButtonInput));
